// libs
import { connect } from 'react-redux';
import get from 'lodash/get';

// components
import Api from './Api';

// redux
import { fetchPDPData as _fetchPDPData } from 'shared/store/details/services';
import { updateStatusCode as _updateStatusCode } from 'shared/store/app/actions';
import { getSSRHeaders, getStoreId } from 'shared/store/app/selectors';
import {
  getErrorSKU,
  getFetchingSKU,
  getProductId,
  getProductSKU,
  isFetching,
} from 'shared/store/details/selectors';

import { resetErrorSku as _resetErrorSku } from 'shared/store/details/actions';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

const mapStateToProps = (state: any, ownProps: any) => {
  const { isMobile = false } = ownProps;
  return {
    storeId: getStoreId(state),
    productID: getProductId(state),
    productSKU: getProductSKU(state),
    isFetching: isFetching(state),
    fetchingSKU: getFetchingSKU(state),
    ssrHeaders: getSSRHeaders(state),
    errorSKU: getErrorSKU(state),
    isPriceReveal: get(
      getRemoteConfig(state, 'priceReveal'),
      isMobile ? 'mobile' : 'desktop',
      false
    ),
  };
};

const mapDispatchToProps = {
  fetchPDPData: _fetchPDPData,
  updateStatusCode: _updateStatusCode,
  reset: _resetErrorSku,
};

export default connect(mapStateToProps, mapDispatchToProps)(Api);
